/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  ShallowContact,
  ShallowContactFromJSON,
  ShallowContactFromJSONTyped,
  ShallowContactToJSON
} from './ShallowContact'

/**
 *
 * @export
 * @interface CreateWithEmailAddressContactResponseData
 */
export interface CreateWithEmailAddressContactResponseData {
  /**
   *
   * @type {ShallowContact}
   * @memberof CreateWithEmailAddressContactResponseData
   */
  contact?: ShallowContact
}

export function CreateWithEmailAddressContactResponseDataFromJSON(
  json: any
): CreateWithEmailAddressContactResponseData {
  return CreateWithEmailAddressContactResponseDataFromJSONTyped(json, false)
}

export function CreateWithEmailAddressContactResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateWithEmailAddressContactResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contact: !exists(json, 'contact') ? undefined : ShallowContactFromJSON(json['contact'])
  }
}

export function CreateWithEmailAddressContactResponseDataToJSON(
  value?: CreateWithEmailAddressContactResponseData | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contact: ShallowContactToJSON(value.contact)
  }
}
